export default __webpack_public_path__ + "static/media/KumbhSans-SemiBold.cc72c8e0.ttf";